import { render, staticRenderFns } from "./DefaultImage.vue?vue&type=template&id=660f41fe&"
import script from "./DefaultImage.vue?vue&type=script&lang=js&"
export * from "./DefaultImage.vue?vue&type=script&lang=js&"
import style0 from "./DefaultImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports